import { ReactNode } from "react";
import { Accordion } from "../..";

import styles from "./FindBestPriceAccordion.module.scss";

interface FindBestPriceAccordion {
  label: string;
  title: string;
  children?: ReactNode;
  expand?: boolean;
  isLoading?: boolean;
  expanded?: boolean;
  disableExpand?: boolean;
  testId?: string;
}

const FindBestPriceAccordion = (props: FindBestPriceAccordion) => {
  const { label, title, children, expanded, expand, isLoading = false, disableExpand = false, testId } = props;

  if (expanded) {
    return (
      <div className={styles.FindBestPriceAccordion}>
        <div className={styles.FindBestPriceAccordionLocationWrapper}>
          <span className={styles.FindBestPriceAccordionLabel}>{label}</span>
          {children}
        </div>
      </div>
    );
  }

  return (
    <Accordion
      label={label}
      title={title}
      className={styles.FindBestPriceAccordion}
      accordionButtonClass={styles.FindBestPriceAccordionButton}
      accordionHeaderClass={styles.FindBestPriceAccordionHeader}
      accordionContentClass={styles.FindBestPriceAccordionContent}
      isLoading={isLoading}
      expand={expand}
      disableExpand={disableExpand}
      testId={testId}
    >
      {children}
    </Accordion>
  );
};

export default FindBestPriceAccordion;
